import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useParams } from 'react-router'

// Store
import { actions } from 'core/store'

// Hooks
import { useLocalStorage } from 'core/hooks/storage'
import { useGetDocumentChunks } from 'core/hooks/api'

// Views
import { AccordionTable, EmptyTablePlaceholder, LoadingTablePlaceholder } from 'views/components'

import AiDocumentChunkTableItem from '../AiDocumentChunkTableItem/AiDocumentChunkTableItem'

// Styled Elements
import { TableWrapper } from './AiDocumentChunkTable.elements'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions
function AiDocumentChunkTable(props) {
  // Destructure
  const { filters, actions, ui } = props
  const { document_id } = useParams()

  // Store States
  const { aiDocumentChunkFilters } = filters
  const { isPageTableUpdated } = ui

  // Store Actions
  const { setAiDocumentChunkFilters, setIsPageTableUpdated } = actions

  // Variables
  const { page, size } = aiDocumentChunkFilters

  // States
  const [docChunks, setDocChunks] = useState({ items: [], total: 0 })

  // Hooks
  const [userCredentials] = useLocalStorage('userCredentials', false)
  const { getDocumentChunksData, getDocumentChunks, isGetDocumentChunksLoading } = useGetDocumentChunks()

  // Functions
  const fetchDocs = () => {
    getDocumentChunks({
      biz_id: userCredentials.Business_ID,
      document_id,
      page,
      size,
    })
  }

  // UseEffects
  useEffect(() => {
    if (getDocumentChunksData) setDocChunks({ ...getDocumentChunksData, ...getDocumentChunksData?.pagination })
  }, [getDocumentChunksData])

  useEffect(() => {
    if (aiDocumentChunkFilters || isPageTableUpdated) {
      fetchDocs()
      setIsPageTableUpdated(false)
    }
  }, [aiDocumentChunkFilters, isPageTableUpdated])

  return (
    <TableWrapper>
      <AccordionTable
        totalItems={docChunks?.total}
        minWidth={900}
        tableFilters={aiDocumentChunkFilters}
        setTableFilters={setAiDocumentChunkFilters}
      >
        {docChunks.items.length > 0 && !isGetDocumentChunksLoading ? (
          docChunks.items.map((details) => <AiDocumentChunkTableItem key={details?.id} data={details} />)
        ) : (
          <div>
            {isGetDocumentChunksLoading ? (
              <LoadingTablePlaceholder />
            ) : (
              <EmptyTablePlaceholder setFilter={setAiDocumentChunkFilters} />
            )}
          </div>
        )}
      </AccordionTable>
    </TableWrapper>
  )
}

// Default Props
AiDocumentChunkTable.defaultProps = {
  actions: {},
  filters: {},
  ui: {},
}

// Proptypes Validation
AiDocumentChunkTable.propTypes = {
  filters: PropTypes.shape({
    aiDocumentChunkFilters: PropTypes.instanceOf(Object),
  }),
  ui: PropTypes.shape({
    isPageTableUpdated: PropTypes.bool,
  }),
  actions: PropTypes.shape({
    setAiDocumentChunkFilters: PropTypes.func,
    setToBeUpdatedVasp: PropTypes.func,
    setIsAiDocumentUploadModalOpen: PropTypes.func,
    setIsEntityVaspDrawerOpen: PropTypes.func,
    setShowHeaderLoader: PropTypes.func,
    setIsPageTableUpdated: PropTypes.func,
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(AiDocumentChunkTable)
